import React, { useState } from 'react';
import TaskTilesSection from './TaskTilesSection';
import { Box, Grid, Paper, useMediaQuery, useTheme } from '@material-ui/core';
import { TaskListLayoutProps } from '../../interfaces';
import TaskListMobilePopup from '../../../shlApp/components/TaskListMobilePopup';
import { SHLApp } from '../../../constants/shlapp';
import { SessionStore } from '../../../constants/sessionStore';
import { genericJourneyTheme } from '../../../common/styles/genericJourneyTheme';
import TaskListProgressBar from './TaskListProgressBar';
import { TaskListToDoStyles } from './styles/taskList';
import Transition from '../../../verticalTransition/components/Transition';
import { useBasicDetails } from '../../../store';
import { verticalTimeline } from '../../../verticalTransition/styles/verticalTimeline';
import { appendCdnToImagePath } from '../../../common/utils/appendCdnToImagePath';
import { TimeLineStyle } from '../../../store/interfaces';
import { TaskListStyles } from '../../styles';

/**
 * TaskListLayout
 * - Layout Container for Banner, CkEditorContent and TaskTilesSection
 */
const TaskListLayout02 = (props: TaskListLayoutProps): JSX.Element => {
  const { isICPEnabled, taskListConfiguration, desktopAssessments, tasks } = props;

  const { sequential, feedbackPage, styles } = taskListConfiguration;

  const isSHLAppAgent = navigator.userAgent.indexOf(SHLApp.IS_SHLAPP_AGENT) === -1;
  const isSHLAndroidAgent = navigator.userAgent.indexOf(SHLApp.IS_SHLAPP_ANDROID_AGENT) > -1;
  const isSHLIOSAgent = navigator.userAgent.indexOf(SHLApp.IS_SHLAPP_IOS_AGENT) > -1;
  const hashTaskList = window.location.hash.indexOf(SHLApp.IS_TASK_LIST) > -1;
  const isAppPrompt = sessionStorage.getItem(SessionStore.isAppPrompt) === 'true';

  const classes = TaskListStyles({ ...taskListConfiguration.styles, isICPEnabled });
  const classesJourneyTheme = genericJourneyTheme();
  const classesToDo = TaskListToDoStyles(taskListConfiguration.styles);
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  const [showShadow, setShowShadow] = useState<boolean>(false);
  const {
    template: {
      settings: {
        page: { timeline, backgroundImage },
      },
    },
  } = useBasicDetails();

  const currentTimelineStyle: TimeLineStyle = {
    lineColor: styles.timeline?.lineColor || timeline.lineColor,
    iconContainerColor: styles.timeline?.iconContainerColor || timeline.iconContainerColor,
    iconColor: styles.timeline?.iconColor || timeline.iconColor,
  };

  const classesTransition = verticalTimeline(currentTimelineStyle);

  const genericPath =
    styles.backgroundImageEnabled && styles.backgroundImage
      ? styles.backgroundImage.path
      : styles.backgroundImageEnabled && !styles.backgroundImage
      ? backgroundImage?.path
      : '';
  const backgroundImagePath = genericPath ? appendCdnToImagePath(genericPath) : '';

  return (
    <>
      <Box className={`${classesJourneyTheme.fixedBG} ${classes.container}`}>
        {styles.backgroundImageEnabled && (
          <img className={classesJourneyTheme.ImgContainer} src={backgroundImagePath} />
        )}
      </Box>
      {mdUp && (
        <TaskListProgressBar tasks={tasks} progressBar={taskListConfiguration.styles.progressBar}></TaskListProgressBar>
      )}

      <div className={classesTransition.verticalGridContentPage}></div>
      <div className={classesJourneyTheme.upLayer}>
        <Transition>
          <Box>
            {isSHLAppAgent && isAppPrompt && !hashTaskList && desktopAssessments && <TaskListMobilePopup />}
            {isSHLAppAgent && !isAppPrompt && hashTaskList && desktopAssessments && <TaskListMobilePopup />}
            {(isSHLAndroidAgent || isSHLIOSAgent) && desktopAssessments && <TaskListMobilePopup />}
            {/*{bannerImageEnabled && bannerImage && <Banner src={bannerImage.path} alt={bannerImage.name} />}*/}
            <Grid justify="center" className={`${classesJourneyTheme.journeyThemeGrid}`}>
              <Paper
                className={`${classesJourneyTheme.journeyThemePaper} 
          ${showShadow ? classesJourneyTheme.bottomShadow : ''} 
          ${showShadow ? classesToDo.bottomShadowTaskList : ''}
          ${classesToDo.containerTaskList}`}>
                <TaskTilesSection
                  sequential={sequential}
                  styles={taskListConfiguration.styles}
                  tasks={tasks}
                  feedbackPage={feedbackPage}
                  setShowShadow={setShowShadow}
                />
              </Paper>
            </Grid>
          </Box>
        </Transition>
      </div>
    </>
  );
};

export default TaskListLayout02;
